import React, {Component} from "react";
import {connect} from "react-redux";

import * as licenseActions from "../../actions/licenseActions";

import LicenseComponent from "../../components/scenes/License";

class License extends Component {
    render() {
        return (
            <LicenseComponent
                processStep={this.props.processStep}
                licenseStatus={this.props.licenseStatus}
                refreshProducts={this.props.dispatchRefreshProductsAction}
                virtualKeyboard={this.props.virtualKeyboard}
            />
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        processStep: store.license.processStep,
        licenseStatus: store.license.licenseStatus,
        virtualKeyboard: store.virtualKeyboard
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchRefreshProductsAction: () => {
            dispatch(licenseActions.refresh());
        }
    };
};

export default License = connect(mapStoreToProps, mapDispatchToProps)(License);
